import { PICKUP_STATUS } from './constants';

export type PickUpStatus = (typeof PICKUP_STATUS)[keyof typeof PICKUP_STATUS];
